/* assets/mm-flavor-cards.js — <mm-flavor-cards>: Tracking für Add to Cart (der Warenkorb selbst läuft über theme.js) */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('mm-flavor-cards')) return;
  class MMFlavorCards extends HTMLElement {
    connectedCallback() { this._onClick = this._onClick.bind(this); this.addEventListener('click', this._onClick); }
    disconnectedCallback() { this.removeEventListener('click', this._onClick); }
    _onClick(evt) {
      var btn = evt.target.closest('[data-mm-atc]'); if (!btn || !this.contains(btn) || btn.disabled) return;
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'mm_add_to_cart', product_id: btn.dataset.productId, variant_id: btn.dataset.variantId, section: 'flavor-cards' });
      }
    }
  }
  customElements.define('mm-flavor-cards', MMFlavorCards);
})();
